export const NEW = 'NEW'
export const ACTIVE = 'ACTIVE'
export const DISPOSED = 'DISPOSED'
export const RESOLVED = 'RESOLVED'
